import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FetchData, Toast } from "../../customHooks/customHooks";
import { ADMIN_PROFILE_UPDATE, USER_INFO_URl, USER_PROFILE_UPDATE } from "../../api";

// -- Async Thunk to Get User Profile --
export const GetUserProfile = createAsyncThunk('user/getProfile', async (_, { rejectWithValue }) => {
    try {
        const response = await FetchData(USER_INFO_URl, {});

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            let { userDetails } = response.data
            return {status : 200, userDetails} // ✅ Return the actual user profile data
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Slice --
const GetUserProfileSlice = createSlice({
    name: 'userProfile',
    initialState: {
        profile: {},
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetUserProfile.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetUserProfile.fulfilled, (state, action) => {
                state.profile = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(GetUserProfile.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});

const IsUpdateProfile = createSlice({
    name : 'User profile',
    initialState : false,
    reducers : {
        setIsUpdateProfile : (state, action) => {
         return state = !state
        }
    }
})

export const AdminProfileUpdate = createAsyncThunk('adminProfileUpdate', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(ADMIN_PROFILE_UPDATE, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', response?.data?.apiStatus?.statusMessage)

            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});


export const UserProfileUpdate = createAsyncThunk('userProfileUpdate', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(USER_PROFILE_UPDATE, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', response?.data?.apiStatus?.statusMessage)

            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});


const handelProfileImage = createSlice({
    name : 'User profile',
    initialState : '',
    reducers : {
        setHenadleProfileImage : (state, action) => {
         return state = action.payload
        }
    }
})

export const {setIsUpdateProfile} = IsUpdateProfile.actions
export const {setHenadleProfileImage} = handelProfileImage.actions

export {
    GetUserProfileSlice,
    IsUpdateProfile,
    handelProfileImage
}
